import { render, staticRenderFns } from "./properties-view.vue?vue&type=template&id=4922190e&scoped=true"
import script from "./properties-view.vue?vue&type=script&lang=js"
export * from "./properties-view.vue?vue&type=script&lang=js"
import style0 from "./properties-view.vue?vue&type=style&index=0&id=4922190e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922190e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4922190e')) {
      api.createRecord('4922190e', component.options)
    } else {
      api.reload('4922190e', component.options)
    }
    module.hot.accept("./properties-view.vue?vue&type=template&id=4922190e&scoped=true", function () {
      api.rerender('4922190e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/properties-view-renderer/properties-view.vue"
export default component.exports